import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableBonusReportView extends JetView {
    // Defining a new class extending JetView
    config() {
        // Method to define the view configuration
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn filter for custom summation behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    // Refresh method for the filter
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        // Iterating through master data
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );
        return {
            rows: [
                // Defining the rows of the UI
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        // Columns within the preloader
                        {
                            view: 'treetable', // Defining a treetable view
                            id: 'treetable', // ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                // Data scheme for grouping
                                $group: {
                                    by: 'ClientCurrency', // Grouping by ClientCurrency
                                    map: {
                                        // Mapping fields for aggregation
                                        Amount: ['Amount', 'sum'],
                                        RolloverRequired: ['RolloverRequired', 'sum'],
                                        AmountConverted: ['AmountConverted', 'sum'],
                                        RolloverWagered: ['RolloverWagered', 'sum'],
                                        RolloverRemaining: ['RolloverRemaining', 'sum'],
                                    },
                                },
                            },
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            columns: [
                                // Defining columns for the treetable
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha Modificación'), // Column header with localization
                                    width: 150, // Column width
                                    template: function (obj, common) {
                                        // Template function for rendering
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Rendering group header
                                        return obj.CreatedLocal; // Returning the CreatedLocal value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        // Template function for details icon
                                        if (obj.$level == 1) {
                                            return ''; // No icon for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon for other levels
                                        }
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PartnerBonusId', // Column ID
                                    header: _('Id Bono'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PartnerBonusName', // Column ID
                                    header: _('Nombre de Bono'), // Column header with localization
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BeginningDate', // Column ID
                                    header: _('Fecha Inicio'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AcceptanceDateLocal', // Column ID
                                    header: _('Fecha Aceptación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BonusType', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha Modificación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AmountConverted', // Column ID
                                    header: _('Monto Convertido'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverRequired', // Column ID
                                    header: _('Rollover Requerido'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverWagered', // Column ID
                                    header: _('Apostado'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'RolloverRemaining', // Column ID
                                    header: _('Restante'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                },
                                {
                                    id: 'ClientBonusExpirationDateLocal', // Column ID
                                    header: _('Fecha Expiración'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CampaingCategory', // Column ID
                                    header: _('Tipo de Campaña'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CampaingDetails', // Column ID
                                    header: _('Detalle de la Campaña'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'LoyaltyAmount', // Column ID
                                    header: _('Puntos de Lealtad Entregados'), // Column header with localization
                                    width: 150, 
                                    sort: 'int', 
                                },
                            ],
                            onClick: {
                                // Event handler for clicking on details icon
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    // Conditional display of details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('formDetails').clear(); // Clear form details
                                        $$('dColl').expand(); // Expand details
                                        $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                    }
                                },
                            },
                            ready: function () {
                                // Event handler when the grid is ready
                                console.log(data); // Log data for debugging
                                this.openAll(); // Open all rows in the grid
                            },
                            autowidth: false, // Disable auto width
                            tooltip: true, // Enable tooltips
                            footer: false, // Disable footer
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }
    init(grid) {
        // Initialization method for the grid
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('treetable'); // Reference to the treetable
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReport'; // API URL for fetching data
        var objectVal = grid.data.pull; // Reference to the grid data
        var filter = ''; // Filter string for API requests

        // Event listener for filtering the bonus report
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to hold query parameters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date for debugging
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom parameter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo parameter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other parameters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add parameter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom parameter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo parameter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object parameters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom parameter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo parameter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            // Load new data based on constructed URL and parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then(function (data) {
                data = data.json(); // Parse JSON response
                var columnsGrid = []; // Array to hold column IDs
                grid.config.columns.forEach((item) => {
                    columnsGrid.push(item.id); // Populate column IDs
                });
                var difference = columnsGrid.filter(
                    (x) => Object.keys(data.data[0]).indexOf(x) === -1, // Find columns not in data
                );
                if (difference.length > 0) {
                    // If there are missing columns
                    difference.forEach((id) => {
                        if (id != 'detailTittle') {
                            grid.hideColumn(id); // Hide missing columns
                        }
                    });
                    grid.refreshColumns(); // Refresh column visibility
                }
            });
            filter = string1; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });
        // Event handler for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
        // Popup for adding bonus balance
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddBonusBalance', // ID for the popup
            width: 450, // Popup width
            height: 450, // Popup height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    {
                        view: 'label',
                        label: _('Añadir bono a saldo'), // Label with localization
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form inside the popup
                id: 'addform', // ID for the form
                elements: [
                    // Form elements
                    {
                        view: 'text',
                        label: _('Usuario Id'), // Label with localization
                        name: 'UserId', // Input name
                        type: 'number', // Input type
                        labelWidth: 150, // Label width
                        required: true, // Required field
                    },
                    {
                        view: 'combo', // Combo box for selecting type
                        label: _('Tipo'), // Label with localization
                        name: 'Type', // Input name
                        required: true, // Required field
                        options: [
                            // Options for the combo box
                            { id: '0', value: _('Premio Torneo Casino') },
                            { id: '1', value: _('Premio Torneo Deportivas') },
                            { id: '2', value: _('Premio Torneo Virtuales') },
                            {
                                id: '3',
                                value: _('Premio Torneo Casino en Vivo'),
                            },
                            { id: '4', value: _('Sorteos') },
                            { id: '5', value: _('Sorteos Casino') },
                            { id: '6', value: _('Sorteos Virtuales') },
                            { id: '7', value: _('Sorteos Casino en Vivo') },
                        ],
                        labelWidth: 150, // Label width
                    },
                    {
                        view: 'combo', // Combo box for selecting balance type
                        label: _('Tipo Saldo:'), // Label with localization
                        name: 'TypeBalance', // Input name
                        required: true, // Required field
                        options: [
                            // Options for the combo box
                            { id: '0', value: _('Saldo recargas') },
                            { id: '1', value: _('Saldo premios') },
                        ],
                        labelWidth: 150, // Label width
                    },
                    {
                        view: 'text', // Text input for reference
                        label: _('Referencia'), // Label with localization
                        name: 'Reference', // Input name
                        labelWidth: 150, // Label width
                        required: true, // Required field
                        type: 'number', // Input type
                    },
                    {
                        view: 'text', // Text input for value
                        label: _('Valor'), // Label with localization
                        name: 'Value', // Input name
                        type: 'number', // Input type
                        labelWidth: 150, // Label width
                        required: true, // Required field
                    },
                    {
                        cols: [
                            // Button row
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type for form submission
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Bonus/AddBonusBalance',
                                                '{"UserId":"' +
                                                    values.UserId +
                                                    '", "Type":"' +
                                                    values.Type +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Reference":"' +
                                                    values.Reference +
                                                    '", "Value":"' +
                                                    values.Value +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse JSON response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Mensaje!', // Alert title
                                                                ),
                                                                type: 'alert-error', // Alert type
                                                                text: json.AlertMessage, // Alert message
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Bono a saldo añadido correctamente', // Success message
                                                                ),
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'), // Alert title
                                            type: 'alert-error', // Alert type
                                            text: _('Completa los campos...'), // Alert message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });
        // Event listener for showing the add bonus balance popup
        this.on(this.app, 'addBonusBalance:button', (filter) => {
            popupAdd.show(); // Show the popup
            $$('addform').clearValidation(); // Clear validation
        });
        // Function to convert file to base64
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader(); // FileReader instance
                reader.readAsDataURL(file); // Read file as data URL
                reader.onload = () => resolve(reader.result); // Resolve promise on load
                reader.onerror = (error) => reject(error); // Reject promise on error
            });
        }
        var base64CSV = ''; // Variable to hold base64 CSV data
        // Popup for adding massive bonus balance
        var popupAdd2 = webix.ui({
            view: 'window',
            width: 450, // Popup width
            height: 450, // Popup height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Añadir bono masivo') }, // Label with localization
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form inside the popup
                id: 'addform2', // ID for the form
                elements: [
                    // Form elements
                    {
                        margin: 10,
                        rows: [
                            {
                                view: 'uploader', // Uploader for CSV files
                                id: 'uploader', // ID for the uploader
                                value: _('Cargar archivo CSV'), // Label for the uploader
                                on: {
                                    onBeforeFileAdd: function (upload) {
                                        // Event before file is added
                                        getBase64(upload.file).then(
                                            (data) => (base64CSV = data), // Convert file to base64
                                        );
                                        $$('uploader').define(
                                            'label',
                                            upload.name, // Update uploader label with file name
                                        );
                                        $$('uploader').refresh(); // Refresh uploader
                                    },
                                },
                            },
                            {
                                view: 'combo', // Combo box for selecting type
                                label: _('Tipo'), // Label with localization
                                name: 'Type', // Input name
                                required: true, // Required field
                                options: [
                                    // Options for the combo box
                                    {
                                        id: '0',
                                        value: _('Premio Torneo Casino'),
                                    },
                                    {
                                        id: '1',
                                        value: _('Premio Torneo Deportivas'),
                                    },
                                    {
                                        id: '2',
                                        value: _('Premio Torneo Virtuales'),
                                    },
                                    {
                                        id: '3',
                                        value: _('Premio Torneo Casino en Vivo'),
                                    },
                                    { id: '4', value: _('Sorteos') },
                                    { id: '5', value: _('Sorteos Casino') },
                                    { id: '6', value: _('Sorteos Virtuales') },
                                    {
                                        id: '7',
                                        value: _('Sorteos Casino en Vivo'),
                                    },
                                ],
                                labelWidth: 150, // Label width
                            },
                            {
                                view: 'combo', // Combo box for selecting balance type
                                label: _('Tipo Saldo:'), // Label with localization
                                name: 'TypeBalance', // Input name
                                required: true, // Required field
                                options: [
                                    // Options for the combo box
                                    { id: '0', value: _('Saldo recargas') },
                                    { id: '1', value: _('Saldo premios') },
                                ],
                                labelWidth: 150, // Label width
                            },
                            {
                                view: 'text', // Text input for reference
                                label: _('Referencia'), // Label with localization
                                name: 'Reference', // Input name
                                labelWidth: 150, // Label width
                                required: true, // Required field
                                type: 'number', // Input type
                            },
                        ],
                    },
                    {
                        cols: [
                            // Button row
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                    $$('addform2').setValues(
                                        $$('addform2').getCleanValues(), // Reset form values
                                    );
                                    $$('uploader').define(
                                        'label',
                                        _('Cargar archivo CSV'), // Reset uploader label
                                    );
                                    $$('uploader').refresh(); // Refresh uploader
                                    base64CSV = ''; // Clear base64 CSV data
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type for form submission
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform2').getValues(); // Get form values
                                    if (
                                        $$('addform2').validate() && // Validate form
                                        base64CSV != '' // Check if CSV data is present
                                    ) {
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Bonus/MassiveAddBonusBalance',
                                                '{"CSV":"' +
                                                    base64CSV +
                                                    '","Type":"' +
                                                    values.Type +
                                                    '","TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '","Reference":"' +
                                                    values.Reference +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse JSON response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Error message
                                                            );
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Bono a saldo añadido correctamente', // Success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'), // Alert title
                                            type: 'alert-error', // Alert type
                                            text: _('Completa los campos...'), // Alert message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });
        // Event listener for showing the add massive bonus balance popup
        this.on(this.app, 'addBonusBalance2:button', (filter) => {
            popupAdd2.show(); // Show the popup
            $$('addform2').clearValidation(); // Clear validation
        });
    }
}

// FILE DOCUMENTED
